<script setup>
import { useNotification } from "../../../../composables/useNotification";
import Notification from "./Notification.vue";

const { notifications } = useNotification();
</script>

<template>
    <div class="fixed bottom-5 right-5 space-y-2">
        <Notification
            v-for="notif in notifications"
            :key="notif.id"
            :message="notif.message"
            :type="notif.type"
            :duration="notif.duration"
            :onClose="
                () =>
                    (notifications = notifications.filter(
                        (n) => n.id !== notif.id
                    ))
            "
        />
    </div>
</template>
